import type { UseIntl } from '../../../types';
import type { FieldErrorsTypes } from './types';

import messages from './messages';

export const validateFormFields = (payload: { email_or_username: string; password: string; }, intl: UseIntl) => {
  const { email_or_username: rawEmailOrUsername, password } = payload;
  const fieldErrors: FieldErrorsTypes = {};

  const emailOrUsername = rawEmailOrUsername.trim();

  if (emailOrUsername === '') {
    fieldErrors.email_or_username = intl.formatMessage(messages.enterEmailOrUsername);
  } else if (emailOrUsername.length < 2) {
    fieldErrors.email_or_username = intl.formatMessage(messages.emailOrUsernameMinLength);
  }

  if (password === '') {
    fieldErrors.password = intl.formatMessage(messages.enterPassword);
  }

  return fieldErrors;
};
